export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.warnHandler = (msg, instance, trace) => {
    if (msg.includes('Slot "default" invoked outside')) return
    if (msg.includes('invoked outside of the render function')) return
    console.warn(msg, trace)
  }
})
